import React from 'react';
import Text from '../text/text.component';
import Gap from '../../interfaces/gap.interface';
import ClassName from '../../interfaces/class-name.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends ClassName, Gap, TestId {
  /** The image's alt text */
  alt: string;

  /** The image's source url */
  src?: string;

  /** A subtitle rendered underneath the title */
  subtitle: string;

  /** The title rendered underneath the image */
  title: string;
}

/** Renders an image with rounded corners and a title/subtitle underneath */
const Avatar = ({
  alt,
  className = '',
  gap = 'none',
  src,
  subtitle,
  title,
  testId,
}: Props): React.ReactElement => (
  <figure
    className={`avatar flex flex-col items-center gap--${gap} ${className}`}
    data-testid={testId}
  >
    <div className="bg-gray-200 flex gap--l items-center justify-center p-6 relative rounded-full w-32 h-32 skeletonize">
      <img src={src} alt={alt} className="rounded-full skeletonize" />
    </div>

    <figcaption>
      <strong className="skeletonize">{title}</strong>
      <Text color="gray-700" align="center">
        {subtitle}
      </Text>
    </figcaption>
  </figure>
);

export default Avatar;
